import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducer from "./reducers";
import * as actions from "./actions";
import AppContainer from './AppContainer';
import {unregister} from './registerServiceWorker';
import { gsntvIframeCommunicationInit } from "./utils/gsntv";



//==============================================


// ---- sounds ------
/*
window.sounds = {};

window.sounds.introBg = new window.Howl({
  src: ['media/10k_Win.mp3']
});

window.sounds.reveal = new window.Howl({
  src: ['media/91926__tim-kahn__ding.mp3']
});

window.sounds.buttonClick = new window.Howl({
  src: ['media/btn_click.mp3']
});

window.sounds.errors = new window.Howl({
  src: ['media/times_up_5.mp3']
});

window.sounds.correct = new window.Howl({
  src: ['media/Correct_Answer_2.mp3']
});

window.sounds.win = new window.Howl({
  src: ['media/Theme.mp3'],
  volume: .5
});

window.sounds.winDingDingDing = new window.Howl({
  src: ['media/Runs_The Board_in_Rd_3.wav']
});

window.sounds.letterReveal = new window.Howl({
  src: ['media/Correct.mp3']
});

window.sounds.clearPuzzle = new window.Howl({
  src: ['media/multimedia_rollover_077.mp3']
});

*/


// ---- toggle sounds when leaving / re-entering site


/*
window.$(window).bind("blur", function(){
	//window.Howler.volume(0);

  window.ppz.app.muteSounds();
});
*/

/*
window.$(window).bind("focus", function(){
	window.Howler.volume(1);
});
*/

/*
window.Howler.volume(1);

//==============================================

window.ppz = {}; // global object for people puzzler game

// debug mode
window.ppz.debug = false;

const urlParams = new URLSearchParams(window.location.search);
const isDebugMode = urlParams.get("debug");

if(isDebugMode === "true"){
  window.ppz.debug = true;

  console.log("debug mode ON");
}


//

window.ppz.firstLoad = true;
*/

window.app = {};

//==============================================




const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

gsntvIframeCommunicationInit(store, actions);


ReactDOM.render(
  <Provider store={store}>
    <AppContainer store={store} />
  </Provider>,
  document.getElementById('root')
);

unregister();






// WEBPACK FOOTER //
// ./src/js/index.js